export default () => ({
    loading:false,
    loadingEmpty:false,
    list:[],
    empty:[]
})